module.exports = __webpack_public_path__ + "static/media/deposit.7cf93a9b.svg";